import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import './SeoLinking.scss';

type SeoLinkingLink = {
  title: string;
  url: string;
  key?: string;
};

type Props = {
  links: SeoLinkingLink[];
};

const SeoLinking: FC<Props> = (props) => {
  return (
    <ul className="seoLinking">
      {props.links.map((link) => (
        <li className="seoLinking__item" key={link.key || link.url}>
          <Link className="seoLinking__link" to={link.url}>
            {link.title}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default SeoLinking;
